import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useMemo, useState } from "react";

export enum RegistrationActiveStepEnum {
  PHONE_VERIFICATION = 0,
  SMS_VERIFICATION = 1,
  PASSWORD_CREATION = 2,
  PERSONAL_INFO = 3,
}

export interface IRegisterContext {
  phone?: string;
  setPhone: Dispatch<SetStateAction<string | undefined>>;
  password?: string;
  setPassword: Dispatch<SetStateAction<string | undefined>>;
  secret?: string;
  setSecret: Dispatch<SetStateAction<string | undefined>>;
  agreements?: Array<number>;
  setAgreements: Dispatch<SetStateAction<Array<number> | undefined>>;
  activeStep: RegistrationActiveStepEnum;
  setActiveStep: Dispatch<SetStateAction<RegistrationActiveStepEnum>>;
}

export const RegisterContext = createContext<IRegisterContext>({} as IRegisterContext);

export const RegisterContextProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [phone, setPhone] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [secret, setSecret] = useState<string>();
  const [agreements, setAgreements] = useState<Array<number>>();
  const [activeStep, setActiveStep] = useState<number>(0);

  const value = useMemo(
    () => ({
      phone,
      setPhone,
      password,
      setPassword,
      secret,
      setSecret,
      agreements,
      setAgreements,
      activeStep,
      setActiveStep,
    }),
    [phone, password, secret, agreements, activeStep]
  );

  return <RegisterContext.Provider value={value}>{children}</RegisterContext.Provider>;
};
